import { toDisplayString as _toDisplayString, openBlock as _openBlock, createBlock as _createBlock } from "vue"

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createBlock("button", {
    type: "button",
    class: "btn btn-primary er fs-6 px-8 py-4",
    style: {"background-color":"#c10017"},
    "data-bs-toggle": "modal",
    "data-bs-target": `#${_ctx.modalId}`
  }, _toDisplayString(_ctx.buttonText), 9, ["data-bs-target"]))
}